import React from 'react';
import {useTranslation} from 'react-i18next';
import {BusinessUnitAccounts} from '../../business_units/accounts/BusinessUnitAccounts';
import {StepLayout} from '../StepLayout';

export function Step4CampaignOnboarding({businessUnitId, onFinish, onBack}) {
    const {t} = useTranslation();

    return (
        <StepLayout
            stepNumber={4}
            title={t('onboarding_wizard.step4_title')}
            description={t('onboarding_wizard.step4_description')}
        >
            {!businessUnitId ? (
                <div className="onboarding-empty-state">
                    <p>{t('onboarding_wizard.step4_missing_control_line')}</p>
                </div>
            ) : (
                <BusinessUnitAccounts
                    embedded={true}
                    accountsOpenByDefault={true}
                    businessUnitId={businessUnitId}
                    onBack={onBack}
                    onComplete={onFinish}
                    backText={t('onboarding_wizard.back_to_previous_step')}
                    finishText={t('onboarding_wizard.finalize')}
                    emptyText={t('onboarding_wizard.step4_no_accounts')}
                />
            )}
        </StepLayout>
    );
}

export default Step4CampaignOnboarding;
